exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#box1[data-v-58d42040]{position:relative;width:100%;height:500px;margin:0 auto}#box2[data-v-58d42040],img[data-v-58d42040]{position:relative;width:100%;height:100%}#wenzi[data-v-58d42040],img[data-v-58d42040]{clear:both}#wenzi[data-v-58d42040]{position:relative;width:450px;top:-60%;left:50%;text-align:center;color:#fff;font-size:30px}", ""]);

// exports
